import http from "@/utils/http";
import common, { simulator as simulatorApi } from "@/modules/common/api";
import { SOURCE } from "@/modules/foz_chapeco/settings";

export default {
    reservoir: {
        getData(startDate, endDate) {
            return common.getReservoirInfos(SOURCE, startDate, endDate);
        }
    },
    simulator: {
        getData(): Promise<any> {
            return http.get("/api/foz-chapeco/simulator/detail/");
        },
        postData(data): Promise<any> {
            return http.post("/api/foz-chapeco/simulator/update/", data);
        },
        simulate(): Promise<any> {
            return simulatorApi.start(SOURCE);
        },
        stopSimulation(): Promise<any> {
            return simulatorApi.stop(SOURCE);
        },
        getStatus(): Promise<any> {
            return simulatorApi.getStatus(SOURCE);
        },
        validate(): Promise<any> {
            return simulatorApi.validate(SOURCE);
        }
    }
};
